import React, { PropsWithChildren } from 'react';
import { SpeedDial, SpeedDialProps } from '@mui/material';

export type FuseSpeedDialProps = PropsWithChildren & {
  /**
   * Screen reader label
   */
  ariaLabel?: string;
  /**
   * Direction to open speed dial
   */
  direction?: SpeedDialProps['direction'];
  /**
   * Speed dial icon
   */
  icon?: React.ReactNode;
};

export const FuseSpeedDial: React.FC<FuseSpeedDialProps> = ({
  children,
  ariaLabel = '',
  direction = 'right',
  icon,
}) => (
  <SpeedDial
    component="md-fab-speed-dial"
    direction={direction}
    className="md-fling md-noop"
    ariaLabel={ariaLabel}
    FabProps={{
      'aria-label': 'menu',
      className: 'md-fab md-mini md-accent md-button md-default-theme',
    }}
    icon={icon}
  >
    {children}
  </SpeedDial>
);
